
import React, { useEffect, useState } from 'react'
import ReactLoading from 'react-loading'
import './styles.scss';

function Preloader1() {

  const [data, setData] = useState([]);
  const [done, setDone] = useState(undefined);

  // useEffect(() => {
  //   setTimeout(() => {
  //     fetch('https://jsonplaceholder.typicode.com/posts')
  //       .then(response => {
  //         if (!response.ok) {
  //           throw new Error(response.statusText)
  //         } else {
  //           (response.json())
  //             .then((json) => {
  //               console.log(json);
  //               setData(json);
  //               setDone(true);
  //             });
  //         }


  //       }).catch(err => {
  //         console.log(err)
  //       })
  //   }, 2000);

  // }, [])


  return (
    <>
      <div className="preloader">
        <ReactLoading type={"bubbles"} color={"#000"} height={100} width={100} />
      </div>

      {/* {
                !done ? <ReactLoading type={"bars"} color={"#000"} height={200} width={200}/>
                :
                (<Directory/>)
            } */}
    </>
  )
}

export default Preloader1
